import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

import { MaintenanceStatus } from '@malou-io/package-utils';

import type { MaintenanceMode } from '#core/maintenance/models/maintenance.interface';

import { withDevtools } from '#shared/store/with-devtools.store.feature';

interface MaintenanceState {
    maintenance: MaintenanceMode;
}

const initialState: MaintenanceState = {
    maintenance: {
        status: MaintenanceStatus.UP,
        until: new Date('2024-01-01'),
        trespass: [],
        redirect: false,
        webhookRedirectActive: false,
        localWebhookUri: '',
    },
};

export const MaintenanceStore = signalStore(
    { providedIn: 'root' },
    withState(initialState),
    withDevtools('Maintenance'),
    withMethods((store) => ({
        editMaintenance(maintenance: MaintenanceMode): void {
            patchState(store, { maintenance });
        },
    }))
);
